module.exports = __webpack_public_path__ + "components/page-header/static/logo-outside--black-5add002a2b1d11f9119701589021869d.svg";